import { AbstractControl, ValidationErrors } from '@angular/forms';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const phoneRegex = /^[0-9-]{12}$/;

  const valid = phoneRegex.test(control.value);
  return valid ? null : { invalidPhoneNumber: $localize`Invalid phone number` };
}
